import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  roleNames: [],
  isAuthenticated: false,
  isLoggedOut: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      if (action.payload?.accessToken) {
        state.user = action.payload;
        state.isAuthenticated = true;
        state.roleNames = action.payload?.roles?.map((role) => role.name) ?? [];
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.isLoggedOut = true;
      state.roleNames = [];
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
